import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ExcelUploadComponent, ExcelUploadResult, UploadProgress } from '../excel-upload/excel-upload.component';

@Component({
  selector: 'app-excel-upload-demo',
  standalone: true,
  imports: [CommonModule, ExcelUploadComponent],
  templateUrl: './excel-upload-demo.component.html',
  styleUrl: './excel-upload-demo.component.css'
})
export class ExcelUploadDemoComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  uploadHistory: ExcelUploadResult[] = [];
  currentProgress: UploadProgress | null = null;
  selectedFile: File | null = null;

  constructor() {}

  ngOnInit(): void {
    // Component initialization
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFileSelected(file: File): void {
    this.selectedFile = file;
    console.log('File selected:', file.name, file.size);
  }

  onUploadProgress(progress: UploadProgress): void {
    this.currentProgress = progress;
    console.log('Upload progress:', progress);
  }

  onUploadComplete(result: ExcelUploadResult): void {
    this.uploadHistory.unshift(result);
    this.currentProgress = null;
    console.log('Upload complete:', result);
  }

  onUploadError(error: string): void {
    console.error('Upload error:', error);
    this.currentProgress = null;
  }

  clearHistory(): void {
    this.uploadHistory = [];
  }

  downloadTemplate(): void {
    // Create a sample Excel template for demonstration
    const sampleData = [
      ['Order ID', 'Product Name', 'Quantity', 'Price', 'Customer Email'],
      ['ORD001', 'Sample Product 1', '2', '29.99', 'customer1@example.com'],
      ['ORD002', 'Sample Product 2', '1', '49.99', 'customer2@example.com'],
      ['ORD003', 'Sample Product 3', '3', '19.99', 'customer3@example.com']
    ];

    // Convert to CSV for simplicity (in a real app, you might use xlsx to create proper Excel files)
    const csvContent = sampleData.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'sample-template.csv';
    link.click();
    window.URL.revokeObjectURL(url);
  }

  formatFileSize(size: number): string {
    if (size < 1024) return `${size} bytes`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  }

  formatTimestamp(timestamp?: Date): string {
    const now = new Date();
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(now);
  }
}